import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AppInner from "./App/AppInner";
import Landing from "./Landing/Landing";
import Auth from "./Auth/Auth";
import "assets/css/main.scss";
import Admin from "Admin/Admin";
import TipRebate from "tip-rebate/tip-rebate";
export default function App() {
  return (
    <>
      <Routes>
        <Route path="" element={<Landing />} />
        <Route path="/app/*" element={<AppInner />} />
        <Route path="/auth/*" element={<Auth />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="/tip-rebate" element={<TipRebate />} />
        <Route path="*" element={<Navigate to="/" replace={true} />} />
      </Routes>
    </>
  );
}
